import React from 'react'
import './Card.scss'

const Card: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    const { children } = props

    return (
        <div className={"card"}>
            {children}
        </div>
    )
}

export default Card